var PAGINATION_SHOW_COUNT = 5;
function getPagination(currentPage, count, isCenter) {
  var pagination = {
    current: currentPage > count && count > 0 ? 1 : currentPage,
    start: 1,
    end: 1,
    count: count
  };

  if (pagination.current > PAGINATION_SHOW_COUNT / 2) {
    pagination.start = pagination.current - Math.floor(PAGINATION_SHOW_COUNT / 2);
  } else if (pagination.current === 0) {
    pagination.start = 1;
  }

  if (pagination.current === 1) {
    pagination.disableBegin = true;
  }

  if (pagination.current === count || count <= 0) {
    pagination.disableLast = true;
  }

  pagination.end = pagination.start + PAGINATION_SHOW_COUNT - 1;

  if (pagination.end >= count) {
    pagination.end = count;
    pagination.start = count - PAGINATION_SHOW_COUNT + 1;

    if (pagination.start < 1) {
      pagination.start = 1;
    }
  }

  if (isCenter) {
    if (pagination.start > 1) {
      pagination.showPre = true;
    }

    if (count - pagination.end > 0) {
      pagination.showNext = true;
    }
  } else {
    if (pagination.current > 1) {
      pagination.showPre = true;
    }

    if (pagination.current < count) {
      pagination.showNext = true;
    }
  }

  return pagination;
}

export { getPagination };
